import { SqlQueryService } from './sql-query.service';

export const services: any[] = [SqlQueryService];

export * from './sql-query.service';
